import script from "./BulkAddElementsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkAddElementsTable.vue?vue&type=script&setup=true&lang=js"

import "./BulkAddElementsTable.vue?vue&type=style&index=0&id=6c7b6bda&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c7b6bda"]])

export default __exports__